export enum RouteNames {
  Login = "login",
  Booking = "booking",
  BookingPayment = "payment",
  BookingCompleteOrder = "complete-order",
  CustomerDisplay = "customer-display",
}
